// Handles a click outside of the passed node
export default function handleClickOutside(node: HTMLElement) {
  const handleClick = (event: MouseEvent) => {
    if (
      node &&
      event.target instanceof HTMLElement &&
      !node.contains(event.target) &&
      !event.defaultPrevented
    ) {
      node.dispatchEvent(new CustomEvent('click_outside'));
    }
  };

  document.addEventListener('click', handleClick, true);

  return {
    destroy() {
      document.removeEventListener('click', handleClick, true);
    }
  };
}
